import { Paper,Stack } from "@mui/material";
import { useState } from "react";
import ChooseNewPassword from "../features/forgot-password/ChooseNewPassword";
import EnterOtp from "../features/forgot-password/EnterOtp";
import SendOtp from "../features/forgot-password/SendOtp";

const ForgotPassword2 = () => {
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState("");

  function onStep1Complete(userEmail: string) {
    setEmail(userEmail);
    setStep(2);
  }

  function onStep2Complete() {
    setStep(3);
  }

  return (
    <Paper sx={{ marginLeft: "auto", marginRight: "auto", width: "600px", padding: "30px" }}>
      <Stack gap={3}>
        <img
          src="/img/BlueGoldLandscape.svg"
          alt="CompanyHQ"
          width={"400px"}
          style={{ margin: "15px 0px 0px 0px" }}
        ></img>
        {step === 1 && <SendOtp onComplete={onStep1Complete}></SendOtp>}
        {step === 2 && <EnterOtp onComplete={onStep2Complete} email={email}></EnterOtp>}
        {step === 3 && <ChooseNewPassword></ChooseNewPassword>}
      </Stack>
    </Paper>
  );
};

export default ForgotPassword2;
